
























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Tabs extends Vue {
    @Prop({ default: [] }) public tabItems!: any[];

    public tabsEvent(action: string, label: any) {
        this.$ga.event('Tabs', 'click', action, label);
    }
}
